
import { useEffect, useState } from "react";
import AnimatedPage from "../components/animatedPage"
import { useSearchParams } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa6";
import EducationLevel from "../components/courseGenerator/educationLevel";
import ChooseCourse from "../components/courseGenerator/chooseCourse";
import MatchCourses from "../components/courseGenerator/matchCourses";
import { FiRepeat } from "react-icons/fi";


const CourseGenerator = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const [student, setStudent] = useState(searchParams.get("student"))

    const academicProfileSubHeading = `Hi ${student}. Let's get matched to courses in UNITEN now!`
    const [q, setQ] = useState((searchParams.get("q") - 0) || 0)
    const [allowNext, setAllowNext] = useState(false)
    const [heading, setHeading] = useState("")
    const [subHeading, setSubHeading] = useState("")
    const [level, setLevel] = useState(-1)


    const data = [
        {
            id: 0,
            heading: "Your academic profile",
            subHeading: academicProfileSubHeading
        },
        {
            id: 1,
            heading: "What do you plan to study",
            subHeading: "Tell us the course or field you are interested in."
        },
        {
            id: 2,
            heading: "What do you plan to study",
            subHeading: "Tell us the course or field you are interested in."
        },
        {
            id: 3,
            heading: "Course Match Results",
            subHeading: "Preview of your best matched courses!"
        }
    ]


    const button1 = `Secondary
(SPM, O-Level)`
    const button2 = `Pre - University
(incl. STPM, UEC,Foundation,Diploma,A-Level)`



    useEffect(() => {
        if (!searchParams.has("student")) {

            const name = prompt("Please enter your name")
            setSearchParams(searchParams => {
                searchParams.set("student", name);
                return searchParams;
            });
            setStudent(name)

        }
    }, [searchParams])

    const handleLevel = (level) => {
        setLevel(level)
        setSearchParams(searchParams => {
            searchParams.set("educationLevel", level + 1);
            return searchParams;
        });
        setAllowNext(false)
    }

    useEffect(() => {
        let d = data.find(f => f.id === q)
        if (d) {
            setHeading(d?.heading)
            setSubHeading(d?.subHeading)
        }

    }, [q])

    const handleNext = () => {
        if (q < 3) {
            setQ(q + 1)
            setSearchParams(searchParams => {
                searchParams.set("q", q + 1);
                return searchParams;
            });
        }
    }

    const handleBack = () => {
        if (q > 0) {
            setQ(q - 1)
            setSearchParams(searchParams => {
                searchParams.set("q", q - 1);
                return searchParams;
            });

        }
    }

    useEffect(() => {
        if (q > 0) {
            document.documentElement.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        }
    }, [q])


    const handleGoBack = () => {
        setQ(0)
       
        // delete all other params
        setSearchParams(searchParams=>{
            searchParams.set("q", 0)
            searchParams.delete("interest")
            searchParams.delete("educationLevel")
            searchParams.delete("educationResult")
            searchParams.delete("educationType")
            return searchParams
        
        })
        setLevel(-1)
        

    }

    return (
        <AnimatedPage>

            <section className="mt-28 flex flex-col w-full  min-h-screen text-[#3E6079]">
                <div className="w-full h-36 flex items-center justify-center shadow-lg ">
                    <div className="w-full   max-w-2xl">
                        <div className="w-full items-center flex flex-col gap-3 ">
                            <ol className="flex items-center w-full list-none  px-12 pr-14  gap-3 justify-center ">
                                <li className="relative w-full ">
                                    <div className="flex items-center">
                                        <div className={`z-10 flex items-center justify-center w-4 h-4 ${q <= 3 ? "bg-[#007AFF]" : "bg-white border border-gray-400"} rounded-full  shrink-0`} />
                                        <div className="flex-grow ml-3 border-t-4 border-gray-200 border-dotted" />
                                    </div>
                                </li>
                                <li className="relative w-full ">
                                    <div className="flex items-center">
                                        <div className={`z-10 flex items-center justify-center w-4 h-4 ${(q > 0 && q <= 3) ? "bg-[#007AFF]" : "bg-white border border-gray-400"} rounded-full  shrink-0`} />

                                        <div className="flex-grow ml-3 border-t-4 border-gray-200 border-dotted" />

                                    </div>
                                </li>
                                <li className="relative  ">
                                    <div className="flex items-center">
                                        <div className={`z-10 flex items-center justify-center w-4 h-4 ${q == 3 ? "bg-[#007AFF]" : "bg-white border border-gray-400"} rounded-full  shrink-0`} />

                                    </div>
                                </li>
                            </ol>
                            <ol className="flex items-center w-full list-none text-xs sm:text-base gap-3 justify-between transition-all">
                                <li className="relative ">
                                    <div className="">
                                        <h3 className="font-medium text-[#607F92] ">Academic Profile</h3>
                                    </div>
                                </li>
                                <li className="relative  ">
                                    <div className="">
                                        <h3 className="font-medium text-[#607F92] ">Course Preference</h3>
                                    </div>
                                </li>
                                <li className="relative ">
                                    <div className="">
                                        <h3 className="font-medium text-[#607F92] ">Match Results</h3>
                                    </div>
                                </li>
                            </ol>

                        </div>

                    </div>
                </div>


                <div className="w-ful h-full flex-1 p-4 lg:p-20 lg:px-28 flex flex-col gap-10">
                    <div className="flex flex-col md:flex-row max-w-4xl gap-5 transition-all">
                        {
                            q === 3 &&
                            <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.2755 -0.00390625C36.1304 -0.00390625 46.551 10.4167 46.551 23.2716C46.551 29.9892 43.7006 36.0444 39.1452 40.2917L40.4651 46.0181L33.7834 44.0357C30.6248 45.6381 27.0555 46.5471 23.2755 46.5471C10.4206 46.5471 0 36.1265 0 23.2716C0 10.4167 10.4206 -0.00390625 23.2755 -0.00390625Z" fill="#E9F3F4" />
                                <path d="M31.8316 21.016C31.8316 16.1935 27.9233 12.2852 23.1008 12.2852C18.2782 12.2852 14.3699 16.1935 14.3699 21.016C14.3699 24.4262 16.3318 27.3742 19.1821 28.8071L20.3788 34.59H25.6892L26.9783 28.8225C29.8492 27.3947 31.8316 24.4365 31.8316 21.0109V21.016Z" fill="#F8E251" />
                                <mask id="mask0_4362_13018" maskUnits="userSpaceOnUse" x="14" y="12" width="18" height="23">
                                    <path d="M31.8316 21.016C31.8316 16.1935 27.9233 12.2852 23.1008 12.2852C18.2782 12.2852 14.3699 16.1935 14.3699 21.016C14.3699 24.4262 16.3318 27.3742 19.1821 28.8071L20.3788 34.59H25.6892L26.9783 28.8225C29.8492 27.3947 31.8316 24.4365 31.8316 21.0109V21.016Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_4362_13018)">
                                    <path d="M23.8196 34.5327C24.8981 31.3331 25.5761 28.0051 25.8688 24.6411C25.9407 23.7886 25.9921 22.9309 26.0126 22.0784C26.0331 21.3388 26.064 20.589 25.9561 19.8545C25.8739 19.2896 25.6942 18.663 25.2114 18.3087C24.6927 17.9338 24.0764 18.0673 23.6296 18.4833C23.0338 19.038 22.777 19.8854 22.6538 20.666C22.5151 21.575 22.5562 22.4995 22.7822 23.3931C22.8387 23.614 23.1314 23.7475 23.3266 23.614C24.7903 22.6125 24.4821 20.5068 24.1534 19.0328C23.9942 18.3189 23.8042 17.4202 22.9773 17.225C22.2378 17.0504 21.6112 17.5845 21.2568 18.1751C20.3889 19.6286 20.2708 21.5545 20.2605 23.2031C20.2451 25.0674 20.4146 26.9368 20.7381 28.7755C21.0925 30.7784 21.6472 32.7454 22.4073 34.6354L23.0287 34.2759C22.89 34.1321 22.7514 33.9934 22.6127 33.8496C22.2789 33.5055 21.755 34.0345 22.0888 34.3735C22.2275 34.5173 22.3662 34.656 22.5048 34.7998C22.7462 35.0463 23.2701 34.7998 23.1263 34.4403C21.945 31.5077 21.2568 28.3903 21.0617 25.2369C20.9692 23.7115 20.9333 22.1451 21.2157 20.6403C21.3493 19.9316 21.529 19.1818 21.8988 18.5603C22.2121 18.0313 22.89 17.6205 23.2136 18.3857C23.3728 18.7606 23.4344 19.1972 23.5166 19.5926C23.609 20.0343 23.6809 20.4811 23.6912 20.9331C23.7066 21.6315 23.5782 22.556 22.9517 22.9874L23.496 23.2082C23.3214 22.5046 23.2701 21.7856 23.3471 21.0615C23.4139 20.4143 23.5782 19.6953 23.9942 19.1818C24.3126 18.7966 24.7184 18.699 24.9906 19.1766C25.2628 19.6542 25.2782 20.2192 25.2884 20.7276C25.3398 23.6756 25.0111 26.6595 24.4102 29.5458C24.0713 31.1687 23.6399 32.7711 23.1057 34.3478C22.9517 34.7998 23.6707 34.9949 23.8196 34.543V34.5327Z" fill="#E2A519" />
                                </g>
                                <path d="M31.8316 21.016C31.8316 16.1935 27.9233 12.2852 23.1008 12.2852C18.2782 12.2852 14.3699 16.1935 14.3699 21.016C14.3699 24.4262 16.3318 27.3742 19.1821 28.8071L20.3788 34.59H25.6892L26.9783 28.8225C29.8492 27.3947 31.8316 24.4365 31.8316 21.0109V21.016Z" stroke="#F8E251" strokeWidth="0.744693" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M26.3163 32.7812H19.3008V41.3786H26.3163V32.7812Z" fill="#CACACB" />
                                <mask id="mask1_4362_13018" maskUnits="userSpaceOnUse" x="19" y="32" width="8" height="10">
                                    <path d="M26.3168 32.7812H19.3013V41.3786H26.3168V32.7812Z" fill="white" />
                                </mask>
                                <g mask="url(#mask1_4362_13018)">
                                    <path d="M18.813 34.9336H27.5439" stroke="#ABABAC" strokeWidth="0.837137" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M18.813 37.082H27.5439" stroke="#ABABAC" strokeWidth="0.837137" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M18.813 39.2344H27.5439" stroke="#ABABAC" strokeWidth="0.837137" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <path d="M31.4773 8.72656L29.3613 10.8425" stroke="#F5DC46" strokeWidth="1.48425" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.6079 8.72656L17.7239 10.8425" stroke="#F5DC46" strokeWidth="1.48425" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M23.5427 9.8343V6.39844" stroke="#F5DC46" strokeWidth="1.48425" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>}

                        <div>
                            <img
                                src="/assets/courseGen.png"
                                alt=""
                                className="max-w-[223px] h-auto max-h-[9rem] object-cover"
                            />
                        </div>
                        <div className="flex flex-col items-start justify-end gap-2">
                            <h2 className="text-3xl font-bold">{heading}</h2>
                            <p className="text-lg ">{subHeading}</p>
                        </div>
                    </div>
                    {
                        q == 3 ?
                            <MatchCourses />
                            :
                            (q == 2 || q == 1)
                                ?

                                <ChooseCourse q={q} />

                                :

                                <>
                                    <div className="flex flex-col gap-5">
                                        <h2 className="text-xl font-semibold">What is your highest education level?</h2>
                                        <div className="flex flex-col md:flex-row gap-3 max-w-4xl">
                                            <button onClick={() => handleLevel(0)} className={`flex-1 ${level === 0 ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 rounded-lg whitespace-preLine`}>{button1}
                                            </button>
                                            <button onClick={() => handleLevel(1)} className={`flex-1 ${level === 1 ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 rounded-lg whitespace-preLine`}>{button2}</button>
                                        </div>
                                    </div>

                                    {level >= 0 && <EducationLevel level={level} handleAllowNext={(d) => {
                                        d === undefined ? setAllowNext(true) : setAllowNext(d)
                                    }} />}
                                </>

                    }
                </div>

                <div className="w-full  border-t p-8 flex items-center justify-between">
                    {

                        <button
                            onClick={handleBack}
                            className={`px-8 py-4 border-2 border-red-800 rounded-lg justify-center items-center gap-4 ${q > 0 ? "visible" : "invisible"} flex `}

                        >
                            <span className="text-red-800 text-base font-bold capitalize flex items-center gap-3"> Back</span>
                        </button>
                    }

                    {
                        q == 3 ?
                            <button className=" px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 inline-flex" onClick={handleGoBack}>
                                <div className="text-white text-base font-bold  capitalize whitespace-nowrap flex items-center gap-3">Generate Again <FiRepeat size={20} /></div>
                            </button>
                            :


                            <button
                                onClick={handleNext}
                                disabled={!allowNext}
                                className={`px-8 py-4 bg-red-800 rounded justify-center self-end items-center gap-4 flex ${allowNext ? "bg-opacity-100" : "bg-opacity-30"} transition-all`}
                            >
                                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Next <FaArrowRight /></span>
                            </button>
                    }

                </div>

            </section>

        </AnimatedPage>

    )
}

export default CourseGenerator